<template>
  <div>
    <div class="modal" id="signinModal" tabindex="-1" aria-labelledby="signinModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="signinModalLabel">{{ $t('signinModal.title') }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">{{ $t('signinModal.emailLabel') }}</label>
                <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" v-model="username" autocomplete="username">
                <div class="form-text">{{ $t('signinModal.noAccountText') }} <span><a :href="signupLink" >{{ $t('signinModal.signUpLink') }}</a></span></div>
              </div>
              <div class="mb-3">
                <label for="exampleInputPassword1" class="form-label">{{ $t('signinModal.passwordLabel') }}</label>
                <input type="password" class="form-control" id="exampleInputPassword1" v-model="password" autocomplete="current-password">
                <div class="form-text"><span><a :href="changePasswordLink">{{ $t('signinModal.resetPasswordLink') }}</a></span></div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ $t('signinModal.closeButton') }}</button>
              <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click.stop="signIn">{{ $t('signinModal.signInButton') }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="modal" id="signoutModal" tabindex="-1" aria-labelledby="signoutModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="signoutModalLabel">{{ $t('signoutModal.title') }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="form-text">{{ $t('signoutModal.confirmText') }}</div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ $t('signoutModal.cancelButton') }}</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="signOut">{{ $t('signoutModal.signOutButton') }}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal errorModal" id="errorModal" tabindex="-1" aria-labelledby="errorModalLabel1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="errorModalLabel1">{{ errorTitle }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="form-text">{{ errorDetails }}</div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ $t('errorModal.closeButton') }}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal cookieModal" id="cookieModal" tabindex="-1" aria-labelledby="cookieModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="cookieModalLabel">{{ $t('cookieModal.title') }}</h5>
          </div>
          <div class="modal-body">
            <div class="form-text">
              <p>{{ $t('cookieModal.description') }}</p>
              <p>
                {{ $t('cookieModal.policyText') }}
                <a target="_blank" :href="privacyLink">{{ $t('cookieModal.policyLink') }}</a>.
              </p>
            </div>
            <div class="row">
              <a :href="cookiesLink" class="btn btn-sm btn-secondary col-lg-3">{{ $t('cookieModal.customizeButton') }}</a>
              <div class="d-none d-lg-block col-lg-3">&nbsp;</div>
              <button type="button" class="btn btn-sm btn-primary col-lg-3" data-bs-dismiss="modal" @click="acceptAllCookies">{{ $t('cookieModal.acceptButton') }}</button>
              <button type="button" class="btn btn-sm btn-secondary col-lg-3" data-bs-dismiss="modal" @click="rejectOptionalCookies">{{ $t('cookieModal.rejectButton') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { i18Utils } from "@/visualcrossing-core/i18utils";
</script>
<script>
import "/src/website-core/vccommunicatorloader.js";
import { VcLocationsStorage } from "/src/visualcrossing-core/vclocationsstorage";
import Modal from 'bootstrap/js/dist/modal';
import translations from '@/translations/signinsignout.js';


export default {
  i18n: {
      messages: translations,
  },
  name: 'SignInSignOut',
  props: {
    msg: String,
  },
  data() {
    return {
      username: null,
      password: null,
      sessionId: null,
      errorTitle: null,
      errorDetails: null,
      cookiesLink: "/cookies/"
    };
  },
  methods: {
    setVcToolbarState() {
      const sessionMenu = document.querySelector(".vctoolbarbutton.session");
      const nosessionMenu = document.querySelector(".vctoolbarbutton.nosession");
      if (!sessionMenu || !nosessionMenu) {
        console.error("Session or no-session menu element not found");
        return;
      }
      if (this.hasSession) {
        sessionMenu.style.display = "flex";
        nosessionMenu.style.display = "none";
      } else {
        sessionMenu.style.display = "none";
        nosessionMenu.style.display = "flex";
      }
    },

    showCookieConfirmation() {
      if (VcLocationsStorage.getValue("hasSetCookies") || window['vc-nocookieprompt']) return;
      const myModalEl = this.$el.querySelector(".cookieModal");
      const modal = new Modal(myModalEl);
      modal.show();
    },

    acceptAllCookies() {
      VcLocationsStorage.enableAllCookies();
    },

    rejectOptionalCookies() {
      VcLocationsStorage.disableAllCookies();
    },

    showError(title, details) {
      this.errorTitle = title;
      this.errorDetails = details;
      const myModalEl = this.$el.querySelector(".errorModal");
      const modal = new Modal(myModalEl);
      modal.show();
    },

    signIn() {
      let me=this;
      vcCommunicator.createsession(this.username, this.password)
        .then(() => {
          console.log("Successful login");
          this.sessionId = vcCommunicator.sessionId;
        })
        .catch((error) => {
          console.log("Failed login");
          this.sessionId = null;
          this.showError(
            me.$t('errorModal.signInErrorTitle'),
            error || me.$t('errorModal.unknownError')
          );
        });
      this.password = null;
    },

    signOut() {
      vcCommunicator.signOut()
        .then(() => {
          this.sessionId = vcCommunicator.sessionId;
          //location.reload();

        })
        .catch((error) => {
          console.log("Sign out failed:", error);
          this.sessionId = null;
        });
    },
  },
  computed: {
    privacyLink() {
      return i18Utils.link("privacy");
    },
    usageLink() {
      return i18Utils.link("usage");
    },
    accountLink() {
      return i18Utils.link("account");
    },
    signupLink() {
      return i18Utils.link("sign-up");
    },
    changePasswordLink() {
      return i18Utils.link("change-password");
    },
    usageLink() {
      return i18Utils.link('usage');
    },
    hasSession() {
      return this.sessionId;
    },
  },
  mounted() {
    console.log("Mounting SigninSignout");
    document.querySelectorAll("a[data-vc-action='open-account']").forEach(anchor => {
        anchor.addEventListener("click", function(event) {
          event.preventDefault();
          i18Utils.redirectTo("account");
        });
    });
    document.querySelectorAll("a[data-vc-action='sign-up']").forEach(anchor => {
        anchor.addEventListener("click", function(event) {
            event.preventDefault();
            i18Utils.redirectTo("sign-up");
        });
    });
    const vcCommunicator = window.vcCommunicator;
    if (!vcCommunicator) {
      console.log("No vcCommunicator");
      return;
    }
    this.sessionId = vcCommunicator.sessionId;
    vcCommunicator.addHandler('createsession', (sessionId) => {
      this.sessionId = sessionId;
      this.setVcToolbarState();
    });
    vcCommunicator.addHandler('terminatesession', () => {
      this.sessionId = null;
      this.setVcToolbarState();
    });

    this.showCookieConfirmation();
    this.setVcToolbarState();
  },
};
</script>

<style scoped></style>
